import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { notificationsFrag } from './fragments';

type Result = { deleted: Boolean };
type Variables = { userId: number };
export const useNotificationMarkAllDeleted = (options?: MutationHookOptions<Result, Variables>) => {
  const mutation = gql`
  ${notificationsFrag}
    mutation markNotificationDelete($userId: Int!) {
      userNotificationMarkAllDeleted(userId: $userId) {
        ...NotificationsFrag
      }
    }
  `;

  return useMutation<Result, Variables>(mutation, options);
};
export default useNotificationMarkAllDeleted;
